import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./BottomMenu.css";

const BottomMenu = ({ isLoggedIn, setLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogin = () => {
    if (isLoggedIn) {
      setLoggedIn(false); // Logout
      navigate("/");
    } else {
      navigate("/login"); // Login
    }
  };

  return (
    <nav className="bottom-menu">
      <Link to="/#admin" className={`menu-item ${location.pathname === "/" ? "active" : ""}`}>
        Início
      </Link>
      

      {/* Rotas do CRUD visíveis apenas se o usuário estiver logado */}
      {isLoggedIn && (
        <>
          <Link to="/upload-assets#admin" className={`menu-item ${location.pathname === "/upload-assets" ? "active" : ""}`}>
            Editar
          </Link>
          <Link to="/produtos#admin" className={`menu-item ${location.pathname === "/produtos" ? "active" : ""}`}>
            Gerenciar ítens
          </Link>
          
        </>
      )}

      {/* Botão de Login/Logout */}
      <button onClick={handleLogin} className="menu-item login-button">
        {isLoggedIn ? "Logout" : "Login"}
      </button>
    </nav>
  );
};

export default BottomMenu;
